var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRays(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166.479,
    height: 166.484,
    viewBox: "0 0 166.479 166.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rays",
    transform: "translate(0.039 0.043)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M14825.9,16590.131h8l-3.316,57.674Zm-9.6-3.559,7.37,3.107-25.461,51.854Zm19.516,3.188,7.412-3.018,18.659,54.67Zm-26.794-9.936,5.657,5.656-43.126,38.439Zm36.1,5.656,5.657-5.656,38.434,43.131Zm-40.377-14.961,3.013,7.412-54.67,18.658Zm47.12,7.688,3.108-7.369,51.854,25.461Zm3.56-17.6,57.674,3.313-57.674,4.684Zm-108.725,4.684,57.674-4.684v8Zm105.337-14.014,54.67-18.658-51.658,26.07Zm-99.07-18.367,54.962,18.1-3.108,7.369Zm92.155,10.818,43.126-38.439-37.469,44.1Zm-74.536-37.469,44.091,37.469-5.657,5.656Zm65.545,33.27,25.461-51.854-18.091,54.961Zm-38.221-51.732,26.075,51.656-7.412,3.018Zm27.989,51.281,3.317-57.674,4.683,57.674Z",
    transform: "translate(-14746.7 -16481.404)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#radial-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRays);
export default __webpack_public_path__ + "static/media/rays.92e23b52d9283b522020e222fbf61bf2.svg";
export { ForwardRef as ReactComponent };